import { Components, Theme } from '@mui/material/styles'

import { PUBLIC_COLOR } from './theme'

export default function themeComponents(): Components<Omit<Theme, 'components'>> {
  return {
    // MuiCssBaseline: {
    //   styleOverrides: {
    //     body: {
    //       backgroundColor: 'black',
    //     },
    //   },
    // },
    // MuiAppBar: {
    //   defaultProps: {
    //     enableColorOnDark: true,
    //   },
    // },
    MuiPaper: {
      // variants: [
      //   {
      //     props: { variant: 'private' },
      //     style: {
      //       // FIXME: WHYUNOWORK
      //       // outlineColor: PUBLIC_COLOR,
      //       // outlineWidth: 1
      //     },
      //   },
      // ],
    },
    MuiSnackbar: {
      defaultProps: {
        autoHideDuration: 4500,
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      },
      // variants: [
      //   {
      //     props: { color: 'snack' },
      //     style: {
      //       color: 'white',
      //       backgroundColor: 'yellow',
      //     },
      //   },
      // ],
    },
    // MuiSnackbarContent: {
    //   defaultProps: {
    //     sx: {
    //       m: 1,
    //     },
    //   },
    //   variants: [
    //     {
    //       props: { color: 'snack' },
    //       style: {
    //         color: 'white',
    //         backgroundColor: 'yellow',
    //       },
    //     },
    //   ],
    // },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 3,
          // paddingTop: 6,
          // paddingBottom: 6,
          // height: 'auto',
        },
      },
      variants: [
        {
          props: { variant: 'namespace' },
          // FIXME: Inherit outlined?
          style: {
            backgroundColor: 'rgba(0,0,0,0)',
            border: '3px solid',
            borderRadius: 6,
            borderColor: '#bdbdbd',
            '[data-mui-color-scheme="dark"] &': {
              borderColor: '#616161',
            },
          },
        },
      ],
    },
    // // MuiTextField: {
    // //   defaultProps: {
    // //     variant: 'outlined',
    // //   },
    // // },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
        followCursor: true,
        placement: 'top',
        enterDelay: 1000,
      },
    },
    MuiIcon: {
      variants: [
        {
          props: { color: 'publish' },
          style: {
            color: PUBLIC_COLOR,
          },
        },
      ],
    },
    MuiIconButton: {
      variants: [
        {
          props: { color: 'publish' },
          style: {
            color: PUBLIC_COLOR, // White too bright for bg color
          },
        },
      ],
    },
    MuiFab: {
      variants: [
        {
          props: { color: 'publish' },
          style: {},
        },
      ],
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained', color: 'danger' },
          style: {
            color: 'black', // White too bright for bg color
          },
        },
        {
          props: { variant: 'contained', color: 'publish' },
          style: {
            color: 'black', // White too bright for bg color
          },
        },
        {
          props: { variant: 'outlined', color: 'share' },
          style: {
            color: 'share', // White too bright for bg color
          },
        },
        {
          props: { variant: 'contained', color: 'share' },
          style: {
            color: 'black', // White too bright for bg color
          },
        },
        {
          props: { variant: 'dashed' },
          style: {
            textTransform: 'none',
            border: '2px dashed lightgrey',
          },
        },
        {
          props: { variant: 'dashed', color: 'danger' },
          style: {
            border: '2px dashed red',
          },
        },
        {
          props: { variant: 'dashed', color: 'warning' },
          style: {
            border: '2px dashed darkorange',
          },
        },
      ],
      // styleOverrides: {
      //   // Name of the slot
      //   root: {
      //     // Some CSS
      //     // fontSize: '1rem',
      //   },
      // },
    },
  }
}
